import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { CareerBoxes } from '@/components/boxes';
import { Job } from '@/types/job';
interface CareerProps {
  jobs: Job[];
}
export function Career(t0) {
  const $ = _c(2);
  const {
    jobs
  } = t0;
  let t1;
  if ($[0] !== jobs) {
    t1 = <div className="relative z-10 mx-auto max-w-192 px-4"><CareerBoxes items={jobs} /></div>;
    $[0] = jobs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}